(function() {
    'use strict';

    angular.module('news')
        .controller('NewsListController', NewsListController);

    NewsListController.$inject = ['$state', 'notificationSrvc', 'newsDataSrvc', 'newsSrvc', 'newsMessagesConst', 'lodashService', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'newsPermissionsConst', 'searchFilterSrvc', 'filterQuerySrvc'];

    function NewsListController($state, notificationSrvc, newsDataSrvc, newsSrvc, newsMessagesConst, lodashService, datatableDefaultPageSizeValueConst, checkSearchSrvc, newsPermissionsConst, searchFilterSrvc, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.newsRows = [];
        self.newsCols = [{
            title: 'ID',
            value: 'pk',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Tytuł',
            value: 'title_pl',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Treść',
            value: 'content_pl',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Data publikacji',
            value: 'publication_date',
            type: 'date',
            searchable: true,
            orderable: true
        }];

        self.modelPermissions = newsPermissionsConst;
        self.searchQuery = {
            title_pl: null,
            content_pl: null,
            publication_date: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getNews();
        }

        function getNews(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    title: self.searchQuery.title_pl,
                    content: self.searchQuery.content_pl,
                    publication_date: searchFilterSrvc.getDateValue(self.searchQuery.publication_date),
                    ordering: self.searchQuery.ordering
                };
            }
            return newsDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.newsRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getNews);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.news.create');
        }

        function onEdit(row) {
            $state.go('layout.news.update', { pk: row.pk });
        }

        function onDelete(row) {
            return newsSrvc.remove(row.title_pl, row.pk, function(response) {
                notificationSrvc.notification("success", newsMessagesConst.delete);
                lodashService.remove(self.newsRows, { pk: row.pk });
                return response;
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getNews();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getNews();
        }
    }
})();
